window.tude = window.tude || { cmd: [] };
tude.cmd.push(function() {
	tude.refreshAdsViaDivMappings([
		{
			divId: 'my-leaderboard-1',
			baseDivId: 'div-gpt-ad-leaderboard-10',
		},
		{
			divId: 'my-leaderboard-1_2',
			baseDivId: 'div-gpt-ad-leaderboard-10',
		},
		{
			divId: 'my-leaderboard-1_3',
			baseDivId: 'div-gpt-ad-leaderboard-10',
		}
	]);
});

window.tude = window.tude || { cmd: [] };
tude.cmd.push(function() {
	tude.refreshAdsViaDivMappings([
		{
			divId: 'my-leaderboard-2',
			baseDivId: 'div-gpt-ad-medium-1',
		},
		{
			divId: 'my-leaderboard-2_2',
			baseDivId: 'div-gpt-ad-medium-1',
		},
		{
			divId: 'my-leaderboard-2_3',
			baseDivId: 'div-gpt-ad-medium-1',
		}
	]);
});